import HomePageList from './HomePageList.vue';
import HomePageDetail from './HomePage.vue';
import HomePageTopicList from './HomePageTopicList.vue';
export default {
  HomePageList,
  HomePageDetail,
  HomePageTopicList,
};
